import BaseGrid from "../sections/view";
import Toolbar from "../sections/toolbar";

import { createState } from "jet-restate";
import { text } from "helpers/templates";

export default class RulesGrid extends BaseGrid {
	config() {
		const _ = this.app.getService("locale")._;
		this.setParam("state", createState({ name: _("Rules"), search: "" }));
		this.Compact = this.getParam("compact", true);

		const ui = super.config();
		webix.extend(
			ui,
			{
				rowHeight: webix.skin.$active.rowHeight + 10,
				headerRowHeight: webix.skin.$active.barHeight + 10,
			},
			true
		);
		ui.columns = [
			{
				id: "short",
				header: _("Name"),
				fillspace: 2,
				sort: "string",
				template: text(this),
			},
			{
				id: "long",
				header: _("Description"),
				fillspace: 2,
				sort: "string",
				template: text(this),
			},
		];

		return {
			margin: 10,
			padding: 10,
			css: "webix_um_tableview",
			cols: [
				{
					rows: [Toolbar, ui],
				},
				{ $subview: "_hidden", name: "default" },
			],
		};
	}

	init() {
		const rules = this.app.getService("local").rules(true);
		this.InitSelf(rules, this.getParam("id"));
		this.on(this.app, "rules.back:click", () => this.HideDetails());
	}

	ShowDetails(id) {
		this.app.callEvent("details:item-click", ["rules", id.toString()]);
	}

	SearchCompare(value, rule) {
		return (
			rule.short.toLowerCase().indexOf(value) > -1 ||
			rule.long.toLowerCase().indexOf(value) > -1
		);
	}
}
